import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { QueryService } from "./query.service";

export function queryGuard(validationFn: (queryService: QueryService) => boolean) {
    return () => {
        const router = inject(Router);
        const queryService = inject(QueryService);

        if (!validationFn(queryService)) {
            return router.parseUrl("/records/query/new");
        }

        return true;
    };
}
